import React from 'react';
import { useWallet } from '../../context/WalletContext';
import { useContractState } from '../../context/ContractContext';
import { pickAvatar } from '../../utils/userAvatar';
import { shortAddress } from '../../utils/format';

export default function UserStrip() {
  const { account } = useWallet();
  const { userId, extended } = useContractState();
  const avatar = pickAvatar(account);
  return (
    <div className="user-strip">
      <div className="avatar"><img src={avatar} alt="avatar" /></div>
      <div className="who">
        <div className="row1">
          <span className="id-tag">ID #{userId || '—'}</span>
          <span className="up-tag">Upline #{extended ? extended.referrerId : '—'}</span>
        </div>
        <div className="name">Trader</div>
        <div className="addr">{account ? shortAddress(account) : '—'}</div>
      </div>
    </div>
  );
}
